import { playInTypes } from './playInTypes'
import PlayIn from '../../../lib/playIn'
import trackActions from '../tracks'
import { mediaType as MediaType } from '@bt-react/constants'
import { closePlayInMediaDrawer } from '../ui/uiActions'
import { CommunicationType } from '../../../services/apiGateway/apiGatewayTypes'
import getVideoSources from '../../../lib/getVideoRendition'
import isEqual from 'lodash/isEqual'
import { setMediaType } from '../room/room'
import docUpdateAndLog from '../../../lib/docUpdateAndLog'
import { addEntry } from '../../../lib/audit'


export const setPlayInUser = (sources: string[], BTID: string) => async (dispatch, getState) => {

  const { playIn, mediaType } = getState().room

  if (mediaType === MediaType.SCREENSHARE) {

    await dispatch(trackActions.unpublishScreen())

  }

  if (playIn.isInactive() && isEqual( playIn.doc.sources, sources ) ){
    playIn.pause(playIn.doc.pausedAt)
  }
  else playIn.init(sources, { initiatedBy: BTID })

}

export const deactivatePlayIn = () => async (dispatch, getState) => {

  try {

    await getState().room.playIn.inactive()

  }
  catch (e){

    addEntry('PresenterService', 'PlayInEndRequested', `Error deactivating playin: ${e}`)

  }

}

export const unsetPlayInUser = () => async (dispatch, getState) => {

  getState().room.playIn.complete()

}
export const setPlayIn = doc => ({ type: playInTypes.SET_PLAY_IN, payload: new PlayIn(doc) })
export const removeDoc = () => ({ type: playInTypes.REMOVE_PLAY_IN_DOC })
export const listenersAdded = () => ({ type: playInTypes.PLAY_IN_LISTENERS_ADDED })
export const videoSelect = (playIn: CommunicationType) => async (dispatch, getState) => {

  const sources = getVideoSources(playIn.sources)
  const { user: { BTID } } = getState()

  dispatch(setMediaType(MediaType.PLAY_IN))
  dispatch(setPlayInUser(sources, BTID))
  dispatch(closePlayInMediaDrawer())

}
export const stopPlayIn = (layoutsActive?: boolean) => async (dispatch, getState) => {

  if (getState().room.mediaType === MediaType.PLAY_IN && !layoutsActive) {
    await docUpdateAndLog(getState().docs.uiDoc, { mediaType: MediaType.WEBCAM }, 'uiDoc')
  }
  dispatch(unsetPlayInUser())

}

export default {
  listenersAdded,
  removeDoc,
  setPlayIn,
  setPlayInUser,
  stopPlayIn,
  unsetPlayInUser,
  videoSelect
}
